import { NgModule } from '@angular/core';
import { AngularMaterialModule } from 'src/app/shared/module/angular-material.module';
import { ApplicationPipesModule } from 'src/app/shared/module/applicationPipesModule';
import { DiagnosticArticleComponent } from "./diagnostic-article.component";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { MatButtonModule } from "@angular/material/button";
import { WiringComponent } from './wiring/wiring.component';
import { ConnectorComponent } from './connector/connector.component';
import { DescriptionComponent } from './description/description.component';
import { LocationComponent } from './location/location.component';
import { FigureCarouselComponent } from 'src/app/diagnostics/component/diagnostic-article/figure-carousel/figure-carousel.componet'; //../figure-carousel/figure-carousel.component'; // Adjust the path accordingly
import { OperationComponent } from './operation/operation.component';
import { RepairComponent } from './repair/repair.component';
import { SpecificationsComponent } from './specifications/specifications.component';
import { TestingComponent } from './testing/testing.component';
import { NoDataComponent } from './no-data/no-data-component';
import { MaxColumnsPipe } from 'src/app/shared/pipes/getMaxColumnsInTable';

@NgModule({
  declarations: [
    DiagnosticArticleComponent,
    ConnectorComponent,
    DescriptionComponent,
    FigureCarouselComponent,
    LocationComponent,
    OperationComponent,
    RepairComponent,
    SpecificationsComponent,
    TestingComponent,
    WiringComponent,
    MaxColumnsPipe,
    NoDataComponent,
  ],
  imports: [
      CommonModule,
      AngularMaterialModule,
      ApplicationPipesModule,
      TranslateModule,
      MatButtonModule,
  ],
  exports: [DiagnosticArticleComponent]
})
export class DiagnosticArticleModule { }
